export function initializeAPP() {
    initialActiveSidebar();
    initializeSimplebar();
}

const initialActiveSidebar = () => {
    // Toggle Sidebar
    var toggle = document.querySelector('[data-toggle="sidebar"]');
    
    if (toggle) {
        toggle.addEventListener("click", function(event) {
            event.preventDefault();
            document.querySelector('.app').classList.toggle('sidenav-toggled');
                        
            const sidebarState = document.querySelector('.app').classList.contains('sidenav-toggled') ? "closed" : "open";
            
            // Crear una fecha de expiración para la cookie
            const expires = new Date();
            expires.setDate(expires.getDate() + 7);
            
            document.cookie = `sidebarState=${sidebarState}; path=/; expires=${expires.toUTCString()}; SameSite=Lax`;
        });
    }
}

const initializeSimplebar = () => {
    var treeviewMenu = document.querySelector('.app-menu');

    if (treeviewMenu) {
        // Activate sidebar treeview toggle
        document.querySelectorAll('[data-toggle="treeview"]').forEach(element => {
            element.addEventListener("click", function(event)  {
                event.preventDefault();
                if (!element.parentElement.classList.contains('is-expanded')) {
                    treeviewMenu.querySelectorAll("[data-toggle='treeview']").forEach(element => {
                        element.parentElement.classList.remove('is-expanded');
                    });
                }
                element.parentElement.classList.toggle('is-expanded');
            });
        });

        // Set initial active toggle
        document.querySelectorAll('[data-toggle="treeview."].is-expanded').forEach(element => {
            element.parentElement.classList.toggle('is-expanded');
        });
    }
}

// Wait until page is loaded
document.addEventListener("DOMContentLoaded", () => initializeAPP());

window.initializeAPP = initializeAPP;
